import { useState } from 'react';

export const useControlModal = (state: boolean) => {
	const [open, setOpen] = useState(state);

	const handleClose = () => {
		setOpen(false);
	};

	const toggle = () => {
		setOpen(!open);
	};

	return { open, handleClose, toggle } as const;
};
